import { RouterModule, Routes } from '@angular/router';

import { ContactUsComponent } from './components/contact-us.component';
import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { MapModule } from '@eview/features/ui/map/map.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

export const routes: Routes = [
  {
    path: '',
    component: ContactUsComponent,
    outlet: 'dashboard'
  }
];

@NgModule({
  imports: [
    SharedModule,
    RouterModule.forChild(routes),
    MapModule,
    FontAwesomeModule
  ],
  declarations: [ContactUsComponent],
  exports: [ContactUsComponent]
})
export class ContactUsModule {}
